
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/import/legacy",
      function () {
        return require("private-next-pages/import/legacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/import/legacy"])
      });
    }
  